import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type AllowedUser = {
    _id: string
    name: string
    email: string
}

export type RoadmapAllowedUsersResponse = {
    success: boolean
    data: {
        roadmap: {
            _id: string
            product: string
            indication: string
            organizationId: string
        }
        allowedUsers: AllowedUser[]
        allOrgUsers: AllowedUser[]
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminRoadmapAllowedUsersQuery = (roadmapId: string) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getRoadmapAllowedUsers = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI(`/api/admin/roadmaps/${roadmapId}/allowed-users`, 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching roadmap allowed users:', e)
            throw e
        }
    }

    return useQuery<RoadmapAllowedUsersResponse>(
        ['admin', 'roadmap', roadmapId, 'allowed-users'],
        getRoadmapAllowedUsers,
        {
            enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!roadmapId,
            cacheTime: FIVE_MINUTES,
            staleTime: 30000,
            retry: 3,
        }
    )
}
